module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0015-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0015-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0015-02.jpg",
      "width": "25%"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0015-02"
    }
  }), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "f0015-02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('strong', [_vm._v("FLY AWAY HOME")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "f0014-01"
    }
  }, [_c('div', {
    staticClass: "imgblock W80"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "f0014-01"
    }
  }, [_c('p', {
    staticClass: "intro1"
  }, [_c('strong', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADY-BIRD,")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADY-BIRD, FLY AWAY HOME")])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('strong', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE FIELD MOUSE IS GONE TO HER NEST")])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('strong', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE DAISIES HAVE SHUT UP THEIR SLEEPY RED EYES")])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('strong', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ND THE BIRDS AND THE BEES ARE AT REST")])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('strong', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADY-BIRD,")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADY-BIRD, FLY AWAY HOME")])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('strong', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE GLOW WORM IS LIGHTING HER LAMP")])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('strong', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE DEW’S FALLING FAST, AND YOUR FINE SPECKLED WINGS")])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('strong', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL FLAG WITH THE CLOSE CLINGING DAMP")])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('strong', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADY-BIRD,")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADY-BIRD, FLY AWAY HOME")])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('strong', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE FAIRY BELLS TINKLE AFAR")])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('strong', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKE HASTE OR THEY’LL CATCH YOU AND HARNESS YOU FAST")])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('strong', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITH A COBWEB TO")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BERON’S STAR")])])]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('em', [_vm._v("Helen Ferris")])])]), _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    attrs: {
      "id": "f0014-01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "f0016-02"
    }
  }, [_c('div', {
    staticClass: "imgblock W70"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-02.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "f0016-02"
    }
  }), _c('div', {
    staticClass: "sidebar2"
  }, [_c('a', {
    attrs: {
      "id": "f0016-02"
    }
  }, [_c('h5', {
    staticClass: "h5"
  }, [_c('strong', [_vm._v("Yarn")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "f0016-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0016-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-01.jpg",
      "width": "7%"
    }
  }), _vm._v(" Medium")])]), _c('a', {
    attrs: {
      "id": "f0016-01"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Shown: Longwood by Cascade Yarns, 100% superwash extrafine merino wool, 3.5 oz (100 g) /191 yd (175 m): Red #04 (MC), 1 ball; Ebony #03 (CC), 1 ball")]), _vm._v(" "), _c('h5', {
    staticClass: "h5"
  }, [_c('strong', [_vm._v("Needles")])]), _vm._v(" "), _c('p', {
    staticClass: "hangtx"
  }, [_vm._v("Size 5 (3.75 mm) set of dpn or size to obtain gauge")]), _vm._v(" "), _c('p', {
    staticClass: "hangtx"
  }, [_vm._v("Size 4 (3.5 mm) set of dpn")]), _vm._v(" "), _c('h5', {
    staticClass: "h5"
  }, [_c('strong', [_vm._v("Notions")])]), _vm._v(" "), _c('p', {
    staticClass: "hangtx"
  }, [_vm._v("Stitch markers")]), _vm._v(" "), _c('p', {
    staticClass: "hangtx"
  }, [_vm._v("Tapestry needle")]), _vm._v(" "), _c('p', {
    staticClass: "hangtx"
  }, [_vm._v("Hand sewing needle and thread")]), _vm._v(" "), _c('p', {
    staticClass: "hangtx"
  }, [_vm._v("Two "), _c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("\" (19 mm) buttons for straps (shown: Slimline #397500084)")]), _vm._v(" "), _c('p', {
    staticClass: "hangtx"
  }, [_vm._v("Four "), _c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v("\" (9 mm) buttons for eyes (shown: La Mode #29641)")]), _vm._v(" "), _c('h5', {
    staticClass: "h5"
  }, [_c('strong', [_vm._v("Gauge")])]), _vm._v(" "), _c('p', {
    staticClass: "hangtx"
  }, [_vm._v("24 sts and 32 rows = 4\" (10 cm) in St st on larger needle")]), _vm._v(" "), _c('p', {
    staticClass: "hangtx"
  }, [_vm._v("Take time to check gauge.")])]), _c('h5', {
    staticClass: "h5"
  }, [_c('a', {
    attrs: {
      "id": "f0016-01"
    }
  }, [_c('strong', [_vm._v("Sizes (refer to size chart, ")])]), _c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/slipper#slipper",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 125")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Child’s S (Child’s M, Child’s L, Child’s XL/Woman’s S)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Finished size:")]), _vm._v(" 6 (6 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(", 6 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(", 7 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(")\" (15 [17, 17, 18.5] cm) foot circumference, 6 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" (7 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(", 8 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(", 8 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(")\" (16 [19.5, 21, 22] cm) foot length")])]), _vm._v(" "), _c('div', {
    staticClass: "note2"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("Note")]), _vm._v(":")]), _vm._v(" Slippers are worked at a firmer gauge than that suggested by the yarn manufacturer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_c('em', [_vm._v("Construction")]), _vm._v(":")]), _vm._v(" Slippers are worked from toe to heel.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch00lev1sec10"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('strong', [_vm._v("SLIPPER")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('h4', {
    staticClass: "h4t",
    attrs: {
      "id": "ch00lev1sec11"
    }
  }, [_c('strong', [_vm._v("Toe")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With CC, larger dpn, and using Judy’s magic CO or other toe-up method, CO 24 sts—12 sts on each of 2 dpn. Pm and join for working in rnds.")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next rnd: K12, pm, k12.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Inc rnd: *K2, M1R, knit to 2 sts before marker, M1L, k2; rep from * once more—4 sts inc’d.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rep inc rnd every other rnd 2 (3, 3, 4) more times—36 (40, 40, 44) sts. Remove marker.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Knit 4 rnds. Change to MC. Knit 4 rnds.")])]), _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "f0017-01"
    }
  }, [_c('div', {
    staticClass: "imgblock W98"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "f0017-01"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch00lev1sec12"
    }
  }, [_c('strong', [_vm._v("Instep")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next rnd: K6 (6, 6, 7), BO 6 (8, 8, 8) sts, knit to end of rnd, then knit to BO sts—30 (32, 32, 36) sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Work back and forth in rows in St st.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next row (WS): Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dec row (RS): K1, ssk, knit to last 3 sts, k2tog, k1—2 sts dec’d.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rep dec row every RS row 2 more times—24 (26, 26, 30) sts. Work even until piece measures 3 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" (5, 5 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(", 6)\" (9 [12.5, 14, 15] cm) from CO, ending with a WS row.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch00lev1sec13"
    }
  }, [_c('strong', [_vm._v("Gusset")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Inc row (RS): K2, M1R, knit to last 2 sts, M1L, k2—2 sts inc’d.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rep inc row every RS row 2 more times—30 (32, 32, 36) sts.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next row (WS): P5 (6, 6, 8), pm, purl to last 5 (6, 6, 8) sts, pm, p5 (6, 6, 8).")])]), _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    attrs: {
      "id": "f0017-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0017-02"
    }
  }, [_c('div', {
    staticClass: "imgblock W98"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-02.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "f0017-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0017-02"
    }
  }), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch00lev1sec14"
    }
  }, [_c('a', {
    attrs: {
      "id": "f0017-02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('strong', [_vm._v("Heel")])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row (RS): Knit to marker, wrap & turn.")])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row (WS): Purl to marker, wrap & turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Knit to 1 st before marker, wrap & turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Purl to 1 st before marker, wrap & turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Knit to 2 sts before marker, wrap & turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Purl to 2 sts before marker, wrap & turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Knit to 3 sts before marker, wrap & turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Purl to 3 sts before marker, wrap & turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Knit to 4 sts before marker, wrap & turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Purl to 4 sts before marker, wrap & turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Knit to 5 sts before marker, wrap & turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Purl to 5 sts before marker, wrap & turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Knit to 6 sts before marker, wrap & turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Purl to 6 sts before marker, wrap & turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Knit to marker, working wraps tog with wrapped sts, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Purl to marker, working wraps tog with wrapped sts, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Sl 1, knit to 1 st before marker, pm, ssk (removing marker), turn—1 st dec’d.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Sl 1, purl to 1 st before marker, pm, p2tog (removing marker), turn—1 st dec’d.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Sl 1, knit to marker, ssk, turn—1 st dec’d.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row: Sl 1, purl to marker, p2tog, turn—1 st dec’d.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rep last 2 short-rows 3 (4, 4, 6) more times—20 sts.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch00lev1sec15"
    }
  }, [_c('strong', [_vm._v("Instep edging")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With RS facing and smaller needle, k20 heel sts, then pick up and knit 56 (66, 70, 74) sts around instep edge—76 (86, 90, 94) sts. Pm and join for working in rnds. Work 4 rnds in k1, p1 rib. BO in patt.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch00lev1sec16"
    }
  }, [_c('strong', [_vm._v("STRAPS")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4t",
    attrs: {
      "id": "ch00lev1sec17"
    }
  }, [_c('strong', [_vm._v("Right slipper only")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With MC, smaller needles, and RS facing, beg 2 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" (3 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(", 3 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(", 3 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(")\" (6.5 [8.5, 9, 9.5] cm) from center back of heel along left edge of instep edging, pick up and knit 7 sts through edge of ribbing.")])]), _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "f0018-01"
    }
  }, [_c('div', {
    staticClass: "imgblock W98"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0018-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "f0018-01"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch00lev1sec18"
    }
  }, [_c('strong', [_vm._v("Left slipper only")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With MC, smaller needles, and RS facing, beg 3 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" (4, 4 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(", 4 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(")\" (8.5 [10, 11, 11.5] cm) from center back of heel along right edge of instep edging, pick up and knit 7 sts through edge of ribbing.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch00lev1sec19"
    }
  }, [_c('strong', [_vm._v("Both slippers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Work in k1, p1 rib until strap measures 1 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" (2, 2 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(", 2 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(")\" (4.5 [5, 5.5, 6.5] cm) from pick-up row, ending with a WS row.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next row (RS): Work 2 sts in patt, BO 3 sts, work in patt to end.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next row (WS): Work 2 sts in patt, CO 3 sts, work in patt to end.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cont in patt until strap measures "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("\" (1.3 cm) from buttonhole. BO in patt.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0018-01"
    }
  }), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch00lev1sec20"
    }
  }, [_c('a', {
    attrs: {
      "id": "f0018-01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('strong', [_vm._v("LADYBUG")])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('h4', {
    staticClass: "h4t",
    attrs: {
      "id": "ch00lev1sec21"
    }
  }, [_c('strong', [_vm._v("Antennae")]), _vm._v(" (make 4)")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("With smaller dpn and CC, CO 4 sts. Work knitted cord until piece measures 1 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("\" (3 cm), referring to Techniques chapter, ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch21#ch00lev1sec248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 122")]), _vm._v(", for instructions.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "ch00lev1sec22"
    }
  }, [_c('strong', [_vm._v("Make bobble")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next row: K2, (knit into front, back, front, back, front, and back) of next st, turn—9 sts.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row (WS): P6, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next short-row (RS): K6, turn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rep last 2 short-rows once more. With RS facing, pass last 2nd, 3rd, 4th, 5th, and 6th sts over first, k1—4 sts. Break yarn and thread tail through rem sts. Fasten securely on inside of cord.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    attrs: {
      "id": "f0019-02"
    }
  }, [_c('div', {
    staticClass: "imgblock W90"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-02.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "f0019-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0019-02"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch00lev1sec23"
    }
  }, [_c('strong', [_vm._v("FINISHING")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "f0019-02"
    }
  }, [_vm._v("Weave in ends. With CC, embroider duplicate st spots as shown on chart, referring to Techniques chapter, ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch21#ch00lev1sec234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 119")]), _vm._v(", for instructions, and referring to photo for placement. Sew larger button under strap at instep. Sew eye buttons and antennae in place as shown.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5s"
  }, [_c('strong', [_vm._v("Stitch Pattern")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('a', {
    attrs: {
      "id": "f0019-01"
    }
  }, [_c('div', {
    staticClass: "imgblock W98"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "f0019-01"
    }
  })]), _c('a', {
    attrs: {
      "id": "f0019-01"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f5415ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 78
// module chunks = 0